import { Outlet } from "react-router-dom";
import { NavSidebar } from "@/components/nav-sidebar";
import { Topbar } from "@/components/topbar";
import { useAnalyticsAccountContext } from "@/analytics";

export function AppLayout() {
  // Register chief account context (plan tier) for monetization segmentation.
  // No-op unless analytics is on and the signed-in user is a chief.
  useAnalyticsAccountContext();
  return (
    <div className="flex h-screen w-screen overflow-hidden print:block print:h-auto print:w-auto print:overflow-visible">
      <NavSidebar />
      <div className="flex flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-auto bg-muted/30 p-6 print:overflow-visible print:bg-white print:p-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
